import React, { Component } from "react";
import { compareModels } from "../../stores/actions/compareModels";
import { Row, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import Autosuggest from "react-autosuggest";
import {
  loadSuggestions,
  updateInputValue,
  clearSuggestions
} from "../../stores/actions/autosuggest";

function getSuggestionValue(suggestion) {
  return suggestion;
}

function renderSuggestion(suggestion) {
  return <span>{suggestion}</span>;
}

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      suggestions: []
    };
    this.value_changed = true;
  }

  lookupDoeEqu_auto = (
    e,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    this.props.compareModels(suggestionValue);
    this.props.setModel(0);
    this.value_changed = true;
  };

  lookupDoeEqu = () => {
    this.props.compareModels(this.state.value);
    this.props.setModel(0);
    this.value_changed = true;
  };

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });

    // if (newValue.length >= 2)
    this.props.onChange(event, { newValue });
  };
  clearAutoComplete = () => {
    this.setState({
      value: ""
    });
  };
  render() {
   

    const { suggestions, isLoading } = this.props.autosuggest;
    const inputProps = {
      placeholder: "Enter legacy model no",
      value: this.state.value,
      onChange: this.onChange
    };
    var errormessage;
    if (this.props.compare.status === "failed" && this.value_changed == true) {
      //alert("display Error");
      errormessage = (
        <Alert variant="warning">{this.props.compare.message || ""}</Alert>
      );
      setTimeout(() => {
        this.props.scrollToError();
      }, 100);
    }
    setTimeout(() => {
      this.value_changed = false;
    }, 1000);
    let clear_search =
      this.state.value != "" ? (
        <i
          class="fa fa-window-close clear-search"
          onClick={this.clearAutoComplete}
          aria-hidden="true"
        ></i>
      ) : (
        <React.Fragment />
      );
    return (
      <div>
        <div className="search-wrapper">
          <p className="mnum">Enter your legacy model number</p>
          <div className="search-field">
            {/*<input
            value={this.state.modelnumber}
            onChange={this.changeModelNumber}
            type="text"
          />*/}

            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={
                this.props.onSuggestionsFetchRequested
              }
              onSuggestionsClearRequested={
                this.props.onSuggestionsClearRequested
              }
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={renderSuggestion}
              inputProps={inputProps}
              onSuggestionSelected={this.lookupDoeEqu_auto}
            />
            {clear_search}
          </div>
          <div className="clear" />
          {errormessage}

          <div className="search-btn">
            <button className="greenbtn" onClick={this.lookupDoeEqu}>
              Lookup New Equivalent Model
            </button>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { value, suggestions, isLoading } = state;

  return {
    value,
    suggestions,
    isLoading,
    ...state
  };

 
  return state;
}
const mapDispatchToProps = dispatch => {
  return {
    onChange(event, { newValue }) {
      dispatch(updateInputValue(newValue));
    },
    onSuggestionsFetchRequested({ value }) {
      dispatch(loadSuggestions(value));
    },
    onSuggestionsClearRequested() {
      dispatch(clearSuggestions());
    },
    compareModels: modeldata => dispatch(compareModels(modeldata))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
